module.exports = __webpack_public_path__ + "img/s_sirakov.9489d944.jpg";